// extracted by mini-css-extract-plugin
export default {"header":"ListPageHeader_header__pPCO0","title":"ListPageHeader_title__yWzZL","subtitle":"ListPageHeader_subtitle__uyx+E","actions":"ListPageHeader_actions__o6VNO"};